<template>
  <!-- Dialog de opciones -->
  <v-dialog
    class="tile"
    v-model="dialogProduct"
    max-width="600"
    :persistent="addingProduct"
    @click:outside="outsideDialog"
    scrollable
    :fullscreen="$vuetify.breakpoint.smAndDown"
    @input="cleanModalOptions"
  >
    <v-card>
      <v-card-title class="pa-0" v-if="activeProduct.imagen">
        <!-- Header con imagen -->
        <v-row
          class="ma-0"
          align="center"
          justify="center"
          v-bind:style=" $vuetify.breakpoint.mdAndDown ? 'max-height:150px;' : 'max-height:200px;' "
          style="overflow:hidden;position:relative;width:100%;"
        >
          <v-img
            :src="activeProduct.imagen"
            :lazy-src="activeProduct.imagen"
            aspect-ratio="1"
            class="white"
            width="100%"
            :max-height=" getImgHeight "
          ></v-img>

          <v-row class="p-absolute bottom d-flex justify-end pa-1 w-100 index-5">
            <v-tooltip v-for="(item) in getAlergenos" :key="item.nombre" color="green" top>
              <template v-slot:activator="{ on }">
                <img
                  :elevation="4"
                  v-on="on"
                  class="ml-1"
                  :src="item.img"
                  :alt="item.nombre"
                  width="24"
                  height="24"
                />
              </template>
              <span class="font-weight-medium">{{item.nombre}}</span>
            </v-tooltip>
          </v-row>
        </v-row>

        <!-- Botones superiores del modal -->
        <v-btn
          width="40"
          height="40"
          elevation="3"
          icon
          color="#ffffff"
          style="background-color:white;"
          small
          absolute
          right
          top
          :disabled="addingProduct"
          @click="dialogProduct=false"
        >
          <v-icon class="black--text ma-auto">mdi-close</v-icon>
        </v-btn>
        <v-btn
          width="40"
          height="40"
          elevation="3"
          icon
          color="#ffffff"
          style="background-color:white;"
          small
          absolute
          left
          top
          :disabled="addingProduct"
          @click="clickNextButton('back')"
        >
          <v-icon class="black--text ma-auto">mdi-arrow-left</v-icon>
        </v-btn>
        <v-col cols="12" class="py-4 py-sm-4 d-flex" align-self="center" justify-self="center">
          <span
            class="text-truncate font-weight-medium"
            style="max-width: 75%"
          >{{ activeProduct.nombre }}</span>

          <!-- Celiaco, picante, etc -->
          <div v-if="activeProduct.caractSeleccionadas">
            <v-tooltip v-if="isVegano(activeProduct.caractSeleccionadas)" color="green" top>
              <template v-slot:activator="{ on }">
                <v-avatar v-on="on" class="ml-1" size="18">
                  <img
                    :src="(isVegano(activeProduct.caractSeleccionadas)).img"
                    :alt="(isVegano(activeProduct.caractSeleccionadas)).nombre"
                  />
                </v-avatar>
              </template>
              <span
                class="font-weight-medium"
              >{{ (isVegano(activeProduct.caractSeleccionadas)).nombre }}</span>
            </v-tooltip>
            <v-tooltip v-if="isCeliaco(activeProduct.caractSeleccionadas)" class color="green" top>
              <template v-slot:activator="{ on }">
                <v-avatar v-on="on" class="ml-1" size="18">
                  <img
                    :src="(isCeliaco(activeProduct.caractSeleccionadas)).img"
                    :alt="(isCeliaco(activeProduct.caractSeleccionadas)).nombre"
                  />
                </v-avatar>
              </template>
              <span
                class="font-weight-medium"
              >{{ (isCeliaco(activeProduct.caractSeleccionadas)).nombre }}</span>
            </v-tooltip>
            <v-tooltip v-if="isPicante(activeProduct.caractSeleccionadas)" class color="green" top>
              <template v-slot:activator="{ on }">
                <v-avatar v-on="on" class="ml-1" size="24">
                  <img
                    :src="(isPicante(activeProduct.caractSeleccionadas)).img"
                    :alt="(isPicante(activeProduct.caractSeleccionadas)).nombre"
                  />
                </v-avatar>
              </template>
              <span
                class="font-weight-medium"
              >{{ (isPicante(activeProduct.caractSeleccionadas)).nombre }}</span>
            </v-tooltip>
          </div>

          <span
            class="ml-auto black--text text--darken-1 font-weight-medium"
          >{{ replaceComa( precioConOpciones) }} €</span>
        </v-col>
      </v-card-title>

      <v-card-title class="pa-0" v-else>
        <!-- Header sin imagen -->
        <v-row
          class="ma-0 w-100"
          align="center"
          justify="center"
          v-bind:style=" $vuetify.breakpoint.mdAndDown ? 'max-height:150px;' : 'max-height:200px;' "
          style="overflow:hidden;position:relative;height: 100px;"
        >
          <v-row class="p-absolute bottom d-flex justify-end pa-1 w-100 index-5">
            <v-tooltip v-for="(item) in getAlergenos" :key="item.nombre" color="green" top>
              <template v-slot:activator="{ on }">
                <img
                  :elevation="4"
                  v-on="on"
                  class="ml-1"
                  :src="item.img"
                  :alt="item.nombre"
                  width="20"
                  height="20"
                />
              </template>
              <span class="font-weight-medium">{{item.nombre}}</span>
            </v-tooltip>
          </v-row>
        </v-row>

        <!-- Botones superiores del modal -->
        <v-btn
          width="40"
          height="40"
          elevation="3"
          icon
          color="#ffffff"
          style="background-color:white;"
          small
          absolute
          right
          top
          :disabled="addingProduct"
          @click="dialogProduct=false"
        >
          <v-icon class="black--text ma-auto">mdi-close</v-icon>
        </v-btn>
        <v-btn
          width="40"
          height="40"
          elevation="3"
          icon
          color="#ffffff"
          style="background-color:white;"
          small
          absolute
          left
          top
          :disabled="addingProduct"
          @click="clickNextButton('back')"
        >
          <v-icon class="black--text ma-auto">mdi-arrow-left</v-icon>
        </v-btn>
        <v-col cols="12" class="py-4 py-sm-6 d-flex" align-self="center" justify-self="center">
          <span class="text-truncate" style="max-width: 75%">{{ activeProduct.nombre }}</span>

          <!-- Celiaco, picante, etc -->
          <div v-if="activeProduct.caractSeleccionadas">
            <v-tooltip v-if="isVegano(activeProduct.caractSeleccionadas)" color="green" top>
              <template v-slot:activator="{ on }">
                <v-avatar v-on="on" class="ml-1" size="18">
                  <img
                    :src="(isVegano(activeProduct.caractSeleccionadas)).img"
                    :alt="(isVegano(activeProduct.caractSeleccionadas)).nombre"
                  />
                </v-avatar>
              </template>
              <span
                class="font-weight-medium"
              >{{ (isVegano(activeProduct.caractSeleccionadas)).nombre }}</span>
            </v-tooltip>
            <v-tooltip v-if="isCeliaco(activeProduct.caractSeleccionadas)" class color="green" top>
              <template v-slot:activator="{ on }">
                <v-avatar v-on="on" class="ml-1" size="18">
                  <img
                    :src="(isCeliaco(activeProduct.caractSeleccionadas)).img"
                    :alt="(isCeliaco(activeProduct.caractSeleccionadas)).nombre"
                  />
                </v-avatar>
              </template>
              <span
                class="font-weight-medium"
              >{{ (isCeliaco(activeProduct.caractSeleccionadas)).nombre }}</span>
            </v-tooltip>
            <v-tooltip v-if="isPicante(activeProduct.caractSeleccionadas)" class color="green" top>
              <template v-slot:activator="{ on }">
                <v-avatar v-on="on" class="ml-1" size="24">
                  <img
                    :src="(isPicante(activeProduct.caractSeleccionadas)).img"
                    :alt="(isPicante(activeProduct.caractSeleccionadas)).nombre"
                  />
                </v-avatar>
              </template>
              <span
                class="font-weight-medium"
              >{{ (isPicante(activeProduct.caractSeleccionadas)).nombre }}</span>
            </v-tooltip>
          </div>

          <span class="ml-auto black--text text--darken-1">{{ replaceComa( precioConOpciones) }} €</span>
        </v-col>
      </v-card-title>

      <v-card-subtitle
        v-if=" opcionesDialog != 'Sin Opciones' && opcionesDialog.panel != undefined "
        class="body-1 text-left black--text text--darken-1 py-3 py-sm-4 px-7 my-0"
        style="background-color: #f6f6f6;"
      >{{ tituloPanel( opcionesDialog.panel ) }}</v-card-subtitle>
      <v-card-text class="pa-0 d-flex">
        <v-container class="my-auto" style="height: 100%;">
          <v-row style="height: 100%;">
            <v-col class="py-0 d-flex flex-column" cols="12">
              <div
                class="d-flex align-center justify-center"
                v-if="loadOptions"
                style="height: 250px"
              >
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </div>
              <!-- DIALOG OPCIONES -->

              <div class="text-center my-auto" v-else>
                <div v-if="opcionesDialog.tipo == 'simple'">
                  <v-list-item-group v-model="arrayOpcionesId[posicionEnModal]">
                    <template v-for="(item, i) in opcionesDialogCorregido">
                      <v-divider v-if="!item" :key="`divider-${i}`"></v-divider>
                      <v-list-item
                        class
                        v-else
                        :key="`item-${i}`"
                        :value="item"
                        @click="clickOpcionSimple(item)"
                        v-bind:class=" !item.mostrar ? 'd-none' : 'd-flex'"
                        :disabled="!item.mostrar || disabledSimpleBtn"
                      >
                        <template v-slot:default="{ active, toggle }">
                          <v-list-item-action class="mr-4">
                            <v-checkbox
                              v-if="item.mostrar"
                              :input-value="active"
                              :true-value="item"
                              color="success"
                              @click="toggle"
                            ></v-checkbox>
                          </v-list-item-action>

                          <v-list-item-content class="text-left">
                            <v-list-item-title v-text="item.nombre"></v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action-text
                            class="body-2 black--text text--darken-1"
                            v-if="precioOpciones(item) > 0"
                          >+ {{ replaceComa( precioOpciones(item) )}} €</v-list-item-action-text>
                        </template>
                        <span
                          class="float-right black--text text--darken-1"
                          v-if="item.precio > 0"
                        >+ {{ replaceComa( precioOpciones(item) )}} €</span>
                        <span
                          class="float-right black--text text--darken-1"
                          v-if="item.precio > 0"
                        >+ {{ item }} €</span>
                      </v-list-item>
                    </template>
                  </v-list-item-group>
                </div>
                <div v-else-if="opcionesDialog.tipo == 'multi'">
                  <!-- Lista para Dialog Multi -->

                  <v-list>
                    <v-list-item-group multiple v-model="arrayOpcionesId[posicionEnModal]">
                      <template v-for="(item, i) in opcionesDialogCorregido">
                        <v-divider v-if="!item" :key="`divider-${i}`"></v-divider>

                        <v-list-item
                          v-else
                          :key="`item-${i}`"
                          :value="item"
                          @click="clickOpcionMultiple(item, opcionesDialog)"
                          v-bind:class=" !item.mostrar ? 'd-none' : 'd-flex'"
                          :disabled="!item.mostrar"
                        >
                          <template v-slot:default="{ active, toggle }">
                            <v-list-item-action class="mr-4">
                              <v-checkbox
                                v-if="item.mostrar"
                                :input-value="active"
                                :true-value="item"
                                color="success"
                                @click="toggle"
                              ></v-checkbox>
                            </v-list-item-action>
                            <v-list-item-content class="text-left">
                              <v-list-item-title v-text="item.nombre"></v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action-text
                              class="body-2 black--text text--darken-1"
                              v-if="precioOpciones(item) > 0"
                            >+ {{ replaceComa( precioOpciones(item) )}} €</v-list-item-action-text>
                          </template>
                        </v-list-item>
                      </template>
                    </v-list-item-group>
                  </v-list>
                </div>
                <div v-else>
                  {{ activeProduct.descripcion }}
                  <br />
                  <br />Elija la cantidad que desea.
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions class="pa-3" v-if="!loadOptions">
        <v-container class="py-0 pl-0 pl-sm-3 pl-sm-0">
          <v-row>
            <v-col
              class="text-center mb-3 mb-sm-0 pt-0 pb-10 py-sm-2 d-flex align-center justify-center"
              cols="12"
              sm="4"
            >
              <v-btn
                outlined
                fab
                dark
                small
                color="green"
                class="mx-2 pa-sm-0"
                @click="restarCantidad()"
                :class=" cantidad == 1 ? 'disabled' : 'd-flex'"
              >
                <v-icon class="ma-auto">mdi-minus</v-icon>
              </v-btn>
              <span class="title px-3">{{ cantidad }}</span>
              <v-btn
                outlined
                fab
                dark
                small
                color="green"
                class="mx-2 pa-sm-0"
                @click="sumarCantidad()"
              >
                <v-icon class="ma-auto">mdi-plus</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" sm="8" class="d-flex align-center pa-0">
              <v-btn
                x-large
                tile
                height="48"
                :disabled="opcionesDialog.tipo == 'simple' && !isLastDialog || opcionesDialog.tipo == 'simple' && isLastDialog && this.emptyOptions()"
                :loading="addingProduct"
                class="ml-auto ma-0 pa-0 body-2 white--text font-weight-bold"
                v-if="opcionesDialog.tipo == 'simple' || isLastDialog || isUniqueDialog"
                block
                color="success"
                @click="addProducto()"
                v-bind:style=" $vuetify.breakpoint.smAndDown ? 'position:absolute;bottom:0px;left:0px;width:100%;right:0px;' : '' "
              >{{ $t('pedido.dialogOpciones.btn.añadir', {cantidad: cantidad}) }}</v-btn>
              <v-btn
                x-large
                tile
                height="48"
                class="ml-auto ma-0 body-2 white--text font-weight-bold"
                v-else
                block
                color="success"
                @click="clickNextButton('next')"
                v-bind:style=" $vuetify.breakpoint.smAndDown ? 'position:absolute;bottom:0px;left:0px;width:100%;right:0px;' : '' "
              >{{ $t('pedido.dialogOpciones.btn.siguiente') }}</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { isArray } from "util";
import { mostrarIdioma, mostrarPrecio } from "@/utils/funciones_auxiliares.js";

export default {
  name: "",
  data() {
    return {
      opcionesSeleccionadas: [],
      precioConOpciones: 0,
      arrayOpcionesId: [],
      posicionEnModal: 0,
      addEnabled: true,
      cantidad: 1,
      loadingOpciones: false,
      addingProduct: false,
      scrollY: 0,
      cartDisplay: "d-none",
      productos2: [],
      disabledSimpleBtn: false
    };
  },
  computed: {
    dialogProduct: {
      get() {
        return this.$store.state.pedido.activeProductDialog;
      },
      set(value) {
        if (value == false) {
          this.outsideDialog();
        }
        this.$store.commit("pedido/setActiveProductDialog", value);
      }
    },
    pedidoProgramado: {
      get() {
        return this.$store.state.pedido.activePedido;
      },
      set(value) {
        //if (value == false){
        //  this.cantidad = 1;
        //}
        //this.$store.commit('pedido/setActiveProductDialog',value)
      }
    },
    cartDrawer: {
      get() {
        return this.$store.state.app.cartDrawer;
      },
      set(value) {
        this.$store.commit("app/setCartDrawer", value);
      }
    },
    selectedOptions: {
      get() {
        let temp = [];
        this.$store.state.pedido.seleccionOpciones.forEach(function(e, i) {
          temp.push(e.id);
        });
        return temp;
      },
      set(value) {
        this.$store.commit("pedido/addOpcion", opcion);
      }
    },
    ...mapState({
      loadOptions: state => state.pedido.loadOptions,
      categories: state => state.restaurante.categorias,
      nombreCat: state => state.pedido.activeCat.id,
      productos: state => state.restaurante.prodActiveCat.productos,
      productsInCategories: state => state.restaurante.allProductos,
      restaurante: state => state.pedido.restaurantePedido,
      activeProduct: state => state.pedido.activeProduct,
      horario: state => state.restaurante.horarios,
      opciones: state => state.restaurante.opcionesActiveProduct,
      rest: state => state.restaurante.slug,
      modo: state => state.config.modoFuncionamiento,
      loadingProd: state => state.restaurante.prodActiveCat.loading,
      windowOrientation: state => state.app.windowOrientation
    }),
    ...mapGetters({
      dialog: "pedido/productDialog",
      opcionesDialog: "pedido/getCurrentDialogOpciones",
      isLastDialog: "pedido/isLastDialog",
      isFirstDialog: "pedido/isFirstDialog",
      isUniqueDialog: "pedido/isUniqueDialog"
    }),
    opcionesDialogCorregido: function() {
      let devolver = [];
      let incompatibles = [];
      let ops = this.opcionesDialog.opciones;
      let selecteds = this.opcionesSeleccionadas;

      if (this.isFirstDialog || this.isUniqueDialog) {
        ops.forEach(op_obj => {
          op_obj.mostrar = true;
          op_obj.nombre = mostrarIdioma(op_obj.title);
          devolver.push(op_obj);
        });
      } else {
        selecteds.forEach(array_op => {
          array_op.forEach(opcion => {
            incompatibles.push(opcion.incomp);
          });
        });

        ops.forEach(op_obj => {
          let id_aux = op_obj.id;
          if (incompatibles.length == 0) op_obj.mostrar = true;
          incompatibles.forEach(array_opcion_incomp => {
            let found = array_opcion_incomp.findIndex(e => e == id_aux);

            if (found < 0) {
              op_obj.mostrar = true;
            } else {
              op_obj.mostrar = false;
            }
          });

          op_obj.nombre = mostrarIdioma(op_obj.title);
          devolver.push(op_obj);
        });
      }

      return devolver;
    },
    getImgHeight() {
      let h;
      if (this.$vuetify.breakpoint.smAndDown) {
        if (this.windowOrientation == 0) {
          h = "110px";
        } else {
          h = "110px";
        }
      } else if (this.$vuetify.breakpoint.md) {
        if (this.windowOrientation == 0) {
          h = "200px";
        } else {
          h = "150px";
        }
      } else {
        h = "200px";
      }

      return h;
    },
    getImgWidth() {
      let w;
      if (this.$vuetify.breakpoint.smAndDown) {
        if (this.windowOrientation == 0) {
          w = "100%";
        } else {
          w = "500px";
        }
      } else if (this.$vuetify.breakpoint.md) {
        if (this.windowOrientation == 0) {
          w = "500px";
        } else {
          w = "500px";
        }
      } else {
        w = "500px";
      }

      return w;
    },
    getAlergenos() {
      let res = [];
      if (this.activeProduct.caractSeleccionadas) {
        let found = this.activeProduct.caractSeleccionadas
          .flat(1)
          .find(e => e.grupo == "alergenos");
        if (found) {
          res = found.caracteristicas;
        }
      }
      return res;
    }
  },
  methods: {
    isPicante(obj) {
      let found = obj.flat(1).find(e => e.grupo == "picante");
      let res = false;

      if (found) {
        let found2 = found.caracteristicas[found.caracteristicas.length - 1];
        if (found2) res = found2;
      }

      return res;
    },
    isCeliaco(obj) {
      let found = obj.flat(1).find(e => e.grupo == "vegano");
      let res = false;

      if (found) {
        let found2 = found.caracteristicas.find(e => e.nombre == "Celiaco");
        if (found2) res = found2;
      }

      return res;
    },
    isVegano(obj) {
      let found = obj.flat(1).find(e => e.grupo == "vegano");
      let res = false;

      if (found) {
        let found2 = found.caracteristicas.find(e => e.nombre == "Vegano");
        if (found2) res = found2;
      }

      return res;
    },
    restarCantidad() {
      this.cantidad <= 1 ? (this.cantidad = 1) : this.cantidad--;
      this.sumaPrecios();
    },
    sumarCantidad() {
      this.cantidad++;
      this.sumaPrecios();
    },
    replaceComa(str) {
      return str
        .toString()
        .trim()
        .replace(".", ",");
    },
    dialogOpenClose(boolean) {
      this.$store.commit("pedido/productDialogOpenClose", boolean);
    },
    addProducto() {
      this.addingProduct = true;
      this.$store.commit("pedido/addOpcion", this.opcionesIdCorregidas());

      this.$store
        .dispatch("pedido/addProducto", {
          cantidad: this.cantidad,
          opcionesName: this.opcionesSeleccionadas.flat()
        })
        .then(() => {
          this.$t("pedido.add_producto.added", {
            prod: this.activeProduct.nombre
          });
        })
        .catch(() => {
          //console.log("error al agregar")
          //let msj = this.$t("pedido.add_producto.error");
          //this.$store.commit("snackbar/setMensajeDanger", { msj: msj });
          //alert("error al agregar");
        })
        .finally(() => {
          this.$store.commit("pedido/setActiveProductDialog", false);
          this.addingProduct = false;
          this.outsideDialog();
        });
    },
    abiertoRecogida() {
      let timetable = new horarios(this.horario.recoger);
      //return timetable.opened()
    },
    clickOpcionSimple(opcion) {
      let _vue = this;

      this.disabledSimpleBtn = true;

      if (this.opcionesSeleccionadas[this.posicionEnModal] == undefined) {
        //Crea el array si no esta creado
        this.opcionesSeleccionadas[this.posicionEnModal] = [opcion];
        this.arrayOpcionesId = this.opcionesId();
      } else {
        let index = this.opcionesSeleccionadas[this.posicionEnModal].findIndex(
          e => {
            return e == opcion;
          }
        );
        if (index >= 0) {
          //Verifica si debe borrar o no
          this.opcionesSeleccionadas[this.posicionEnModal].splice(index, 1);
        } else {
          this.opcionesSeleccionadas[this.posicionEnModal] = [opcion];
          this.arrayOpcionesId = this.opcionesId();
        }
      }

      if (!this.isLastDialog) {
        setTimeout(function() {
          _vue.posicionEnModal += 1;
          _vue.$store.commit("pedido/nextDialog");
          let oneOption = _vue.soloUnaOpcion();

          if (oneOption) {
            _vue.posicionEnModal += 1;
            _vue.$store.commit("pedido/nextDialog");
            _vue.opcionesSeleccionadas[_vue.posicionEnModal] = [oneOption];
            _vue.arrayOpcionesId = _vue.opcionesId();
          }
        }, 500);
      }

      this.sumaPrecios();
      setTimeout(function() {
        _vue.disabledSimpleBtn = false;
      }, 500);
    },
    clickOpcionMultiple(opcion) {
      if (this.opcionesSeleccionadas[this.posicionEnModal] == undefined) {
        //Crea el array si no esta creado
        this.opcionesSeleccionadas[this.posicionEnModal] = [opcion];
      } else {
        let index = this.opcionesSeleccionadas[this.posicionEnModal].findIndex(
          e => {
            return e == opcion;
          }
        );
        if (index >= 0) {
          //Verifica si debe borrar o no
          this.opcionesSeleccionadas[this.posicionEnModal].splice(index, 1);
        } else {
          this.opcionesSeleccionadas[this.posicionEnModal].push(opcion);
        }
      }
      this.sumaPrecios();
      this.arrayOpcionesId = this.opcionesId();
      this.$forceUpdate(); //compatibilidades en vivo
    },
    clickNextButton(value) {
      //Values: next/back
      if (value == "next") {
        this.$store.commit("pedido/nextDialog");
        this.posicionEnModal += 1;
      } else {
        if (this.isFirstDialog || this.isUniqueDialog) {
          this.outsideDialog();
          this.dialogProduct = false;
        } else {
          if (this.opcionesSeleccionadas[this.posicionEnModal]) {
            this.opcionesSeleccionadas.pop();
          }
          this.opcionesSeleccionadas.pop();
          this.$store.commit("pedido/lastDialog");
          this.posicionEnModal -= 1;
        }
      }

      this.arrayOpcionesId = this.opcionesId();
      this.sumaPrecios();

      let oneOption = this.soloUnaOpcion(); //Sigue avanzando o retrocediendo si solo hay una opción

      if (oneOption) {
        this.clickNextButton(value);
      }
    },
    emptyOptions() {
      if (this.opcionesSeleccionadas[this.posicionEnModal] != undefined) {
        return this.opcionesSeleccionadas[this.posicionEnModal].length == 0;
      } else {
        return true;
      }
    },
    opcionesId() {
      let temp = [];

      this.opcionesSeleccionadas.forEach(e1 => {
        let aux = [];
        e1.forEach(e2 => {
          let id = e2.id;
          aux.push(id);
        });
        aux = JSON.parse(JSON.stringify(aux));
        temp.push(aux);
      });
      temp = JSON.parse(JSON.stringify(temp));

      return temp;
    },
    opcionesIdCorregidas() {
      var arrToConvert = this.opcionesId();
      var newArr = [];
      for (var i = 0; i < arrToConvert.length; i++) {
        if (arrToConvert[i] && arrToConvert[i].length > 0)
          newArr = newArr.concat(arrToConvert[i]);
      }

      return newArr;
    },
    cleanModalOptions() {
      this.opcionesSeleccionadas = [];
      this.arrayOpcionesId = [];
      this.precioConOpciones = 0;
      this.posicionEnModal = 0;
    },
    outsideDialog() {
      this.cantidad = 1;
      this.cleanModalOptions();
      this.$store.commit("pedido/resetActiveProduct");
    },
    preseleccionado(item) {
      let boolean = false;
      let index = this.arrayOpcionesId.flat().findIndex(function(e) {
        if (e != undefined) {
          return e.id == item.id;
        } else {
          return false;
        }
      });

      index >= 0 ? (boolean = true) : (boolean = false);
      return boolean;
    },
    ...mapActions({
      getCategorias: "restaurante/getCategorias",
      getProductos: "restaurante/getProductosCategoria",
      getAllProducts: "restaurante/getAllProducts"
    }),
    soloUnaOpcion() {
      let devolver = false;
      let incompatibles = [];
      let ops = this.opcionesDialog.opciones;
      let selecteds = this.opcionesSeleccionadas;
      let contador = 0;

      selecteds.forEach(array_op => {
        array_op.forEach(opcion => {
          if (opcion.incomp) {
            incompatibles.push(opcion.incomp);
          }
        });
      });

      //iteramos sobre las opciones para mostrar las compatibles
      if (isArray(ops)) {
        let opcionUnica;

        ops.forEach(op_obj => {
          if (incompatibles.length > 0) {
            //Si no hay compatibilidades, comprueba que esté seteado en el propio objeto

            let found = incompatibles.flat(2).findIndex(e => e == op_obj.id);

            if (found < 0) {
              op_obj.mostrar = true;
              opcionUnica = op_obj;
              contador++;
            } else {
              op_obj.mostrar = false;
            }

            // incompatibles.forEach((array_opc_incomp)=>{
            // 	if (array_opc_incomp.indexOf(parseInt(id_aux,10))<0){
            // 		console.log( op_obj, "no mostrar")
            // 		op_obj.mostrar = false;

            // 	} else {
            // 		console.log( op_obj, " mostrar")
            // 		op_obj.mostrar = true;
            // 		contador++;
            // 		opcionUnica = op_obj;
            // 	}
            // })
          } else {
            // if (op_obj.mostrar == true){
            // 	contador++;
            // 	opcionUnica = op_obj;
            // }
          }
        });

        //Si solo hay una opcion, la añade y pasa al siguiente modal
        if (
          contador == 1 &&
          this.opcionesDialog.tipo == "simple" &&
          !this.isLastDialog &&
          !this.isFirstDialog
        ) {
          devolver = opcionUnica;
        }
      }
      return devolver;
    },
    sumaPrecios() {
      let _vue = this;
      let precioBase = parseFloat(mostrarPrecio(this.activeProduct, this.modo));

      this.opcionesSeleccionadas.flat(2).forEach(function(e) {
        precioBase += parseFloat(mostrarPrecio(e, _vue.modo));
      });

      this.precioConOpciones = (precioBase * this.cantidad).toFixed(2);
    },
    precioOpciones(prod) {
      return mostrarPrecio(prod, this.modo);
    },
    tituloPanel(data) {
      return mostrarIdioma(data);
    }
  },
  mounted() {},
  watch: {
    dialogProduct(newVal) {
      if (newVal == true) this.sumaPrecios();
    }
  }
};
</script>

<style scoped>
.v-banner--is-mobile div.v-banner__wrapper {
  padding: 0px !important;
}
.circle {
  border-radius: 50%;
}
.p-absolute {
  position: absolute;
}
.p-sticky {
  position: sticky;
  border-bottom: 1px solid #dbdbdb;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;
}
.tile {
  border-radius: 0px;
}
.bottom {
  bottom: 0px;
}
.top {
  top: 0px;
}
.index-1 {
  z-index: 1;
}
.index-5 {
  z-index: 5;
}
.overflow-x {
  overflow-x: hidden;
}
.w-100 {
  width: 100%;
}
.mw-100 {
  max-width: 100%;
}
.vh-75 {
  height: 75vh;
}
.v-tabs:not(.v-tabs--vertical) .v-tab {
  white-space: nowrap;
  width: auto !important;
  text-transform: initial;
  color: rgba(0, 0, 0);
}
.all-window-absolute {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
}
/* Navbar categorias */
.card {
  background-color: #fff;
  min-width: 100%;
}
.card::-webkit-scrollbar {
  display: none;
}
.card--content {
  white-space: nowrap;
  width: auto !important;
  text-transform: initial;
  cursor: pointer;
}
.slider-wrapper {
  width: 100px;
  height: 2px;
  background-color: #4caf50;
  border: 1px solid #4caf50;
  position: absolute;
  bottom: 0px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #f6f6f6 !important;
}

.v-list-item--link::before {
  background-color: transparent !important;
}
.border {
  border: 1px solid black;
}
.v-tooltip__content {
  opacity: 1 !important;
}

@media only screen and (max-width: 992px) {
  .overflow-x {
    overflow-x: auto;
  }
}
</style>
